const getters = {
  isLand: state => state.user.isLand,
  landTip: state => state.user.landTip,
  projectInfo: state => state.project.projectInfo,
  columns: state => state.project.columns,
  task: state => state.project.task,
  uploaderPath: state => state.system.uploaderPath,//文件上传路径
  localPath: state => state.system.localPath,//local地址
  fileNum: state => state.share.fileNum,
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js